/* eslint-disable no-use-before-define */
import * as types from "./actionTypes";
import cookie from "js-cookie";
import fetchUrl from "../../services/fetchUrl";
import {
  ERROR_MESSAGE,
  GA4_TRACKING_ID,
  LOGGED_OUT_MSG,
  ProfileAttr,
  STORAGE_ITEMS
} from "../../services/constants";
import makeAjaxRequest from "../../services/makeAjaxRequest";
import Router from "next/router";
import {
  showSnackBar,
  showGenericSnackBar
} from "../../components/Snackbar/snackbarActions";
import { logEvents, setAppLoader } from "../../redux/commonActions";
import {
  OTP_VERIFICATION_SUCCESS,
  INVALID_OTP,
  USER_LOGIN_COMPLETE,
  FIRST_TIME_USER,
  RETURNING_TIME_USER,
  VERIFIED_SCREEN_SHOWN
} from "../../services/webengage/webEngageConstants";
import {
  EMAIL_VERIFICATION,
  CANDIDATE_LISTING,
  JOB_POSTING_FORM,
  LOADING_PAGE
} from "../../routes/RouteConstants";
import {
  detectMobile,
  getErrorMessage,
  signOut,
  getCookieDomain
} from "../../services/utils";
import { getCookie } from "../../services/cookie";
import ClmGetTrackingService from "../../services/ClmTrackingService";
import useUserProfileStore from "../../zustandStores/userProfileStore";

export const getRoles = (
  username,
  password,
  job_id,
  emailError,
  callback,
  repost
) => {
  return dispatch => {
    dispatch(getRolesLoading());
    dispatch(setAppLoader(true));
    makeAjaxRequest({
      method: "POST_NO_AUTH",
      url: fetchUrl("auth/recruiter/v2", "verify_otp"),
      data: {
        phone: username,
        otp: password,
        utm_source: getCookie("utm_source"),
        utm_medium: getCookie("utm_medium"),
        utm_campaign: getCookie("utm_campaign"),
        utm_content: getCookie("utm_content"),
        utm_term: getCookie("utm_term")
      },
      customHeaders: { "device-source": detectMobile() ? "M-site" : "Desktop" }
    })
      .then(response => {
        dispatch(getRolesSuccess(response.data.data));
        if (response.data.data) {
          const { is_returning_user, recruiter_id } = response.data.data;
          ClmGetTrackingService().login(recruiter_id);

          if (is_returning_user) {
            dispatch(logEvents(RETURNING_TIME_USER));
          } else {
            dispatch(logEvents(FIRST_TIME_USER));
          }
        }
        dispatch(logEvents(USER_LOGIN_COMPLETE, { username: username }));
        dispatch(logEvents(VERIFIED_SCREEN_SHOWN));
        dispatch(
          getProfile({
            page: "login",
            queryJobId: job_id,
            emailError: emailError,
            hardCheck: true,
            repost
          })
        );
      })
      .catch(error => {
        dispatch(setAppLoader(false));
        if (callback) callback();
        let errorMessage = "";
        if (error && error.response) {
          if (error.response.data) {
            errorMessage = error.response.data.error;
          } else {
            errorMessage = ERROR_MESSAGE;
          }
        } else {
          errorMessage = ERROR_MESSAGE;
        }
        dispatch(getRolesFailure(errorMessage));
        dispatch(logEvents(INVALID_OTP, { phone: username }));
        dispatch(showSnackBar(errorMessage));
      });
  };
};

export const getLeadGenRoles = ({ username, password, callback }) => {
  return dispatch => {
    dispatch(getRolesLoading());
    dispatch(setAppLoader(true));
    makeAjaxRequest({
      method: "POST_NO_AUTH",
      url: fetchUrl("auth/recruiter/v2", "verify_otp"),
      data: {
        phone: username,
        otp: password,
        flow: "logged_out_lead",
        utm_source: getCookie("utm_source"),
        utm_medium: getCookie("utm_medium"),
        utm_campaign: getCookie("utm_campaign"),
        utm_content: getCookie("utm_content"),
        utm_term: getCookie("utm_term")
      },
      customHeaders: { "device-source": detectMobile() ? "M-site" : "Desktop" },
      isLogoutAllDevices: false
    })
      .then(response => {
        dispatch(getRolesSuccess(response?.data?.data));
        dispatch(setAppLoader(false));

        if (response?.data?.data) {
          const { is_returning_user, recruiter_id } = response?.data?.data;
          ClmGetTrackingService().login(recruiter_id);

          if (is_returning_user) {
            dispatch(logEvents(RETURNING_TIME_USER));
          } else {
            dispatch(logEvents(FIRST_TIME_USER));
          }
        }
        dispatch(logEvents(USER_LOGIN_COMPLETE, { username: username }));
        dispatch(logEvents(VERIFIED_SCREEN_SHOWN));
        if (callback) callback();
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(showSnackBar(errorMessage));
        dispatch(setAppLoader(false));
        dispatch(getRolesFailure(errorMessage));
        dispatch(logEvents(INVALID_OTP, { phone: username }));
      });
  };
};

export const getRolesLoading = () => {
  return {
    type: types.GET_ROLES_LOADING
  };
};

export const getRolesSuccess = payload => {
  const cookieDomain = getCookieDomain();

  cookie.set("rec_access_token", payload.token, {
    expires: 365,
    domain: cookieDomain
  });
  cookie.set("is_returning_user", payload.is_returning_user, {
    expires: 365,
    domain: cookieDomain
  });
  return {
    type: types.GET_ROLES_SUCCESS,
    payload: payload
  };
};

export const getRolesFailure = error => {
  return {
    type: types.GET_ROLES_FAILURE,
    payload: error
  };
};

export const getProfile = (params = {}) => {
  const {
    page,
    queryJobId,
    emailError,
    isLoader = true,
    hardCheck = false,
    callback,
    repost
  } = params;
  return async (dispatch, store) => {
    return new Promise((resolve, reject) => {
      try {
        const reduxStore = store() || {};
        const { userProfileReducer } = reduxStore;
        const payloadData = userProfileReducer?.payload?.data || {};
        const storedSessionId = userProfileReducer?.payload?.sessionId;
        const checkForCacheAncCacheExists =
          !hardCheck &&
          userProfileReducer?.isSuccess &&
          userProfileReducer?.payload &&
          Object.keys(payloadData).length &&
          (function () {
            if (process.browser) {
              return (
                storedSessionId ==
                localStorage.getItem(STORAGE_ITEMS.recruiterSessionId)
              );
            }
            return true;
          })();
        if (checkForCacheAncCacheExists) {
          const { payload: cachePayload } = userProfileReducer;
          const payload = JSON.parse(JSON.stringify(cachePayload));
          dispatch(getProfileSuccess(payload));
          // Update Zustand store with cached data
          useUserProfileStore.getState().setProfileSuccess(payload.data);
          if (callback) {
            callback(payload);
          }
          return resolve(payload);
        }

        if (isLoader) {
          dispatch(getProfileLoading());
          // Update Zustand loading state
          useUserProfileStore.getState().setProfileLoading();
        }

        makeAjaxRequest({
          method: "GET",
          url: fetchUrl("recruiter", "profile"),
          auth: true
        })
          .then(response => {
            const profilePayload = {
              ...response.data,
              sessionId: (function () {
                if (process.browser) {
                  return localStorage.getItem(STORAGE_ITEMS.recruiterSessionId);
                }
                return "";
              })()
            };

            dispatch(getProfileSuccess(profilePayload));
            // Update Zustand store with fresh data
            useUserProfileStore
              .getState()
              .setProfileSuccess(response.data.data);

            if (callback) {
              callback(response.data);
            }
            let recruiterData = response.data.data;
            setWebEngageData(recruiterData);
            const { recruiter_id, phone } = recruiterData;

            if (page === "login") {
              dispatch(
                logEvents(OTP_VERIFICATION_SUCCESS, {
                  phone: phone,
                  recruiter_id: recruiter_id
                })
              );

              if (window.gtag) {
                window.gtag("config", GA4_TRACKING_ID, {
                  user_id: recruiter_id
                });
              }
              if (window.clarity) {
                window.clarity("identify", String(`${recruiter_id}`));
              }
              if (emailError === "true") {
                Router.push({
                  pathname: EMAIL_VERIFICATION,
                  query: {
                    emailError: true
                  }
                });
              } else {
                if (queryJobId && repost) {
                  Router.push({
                    pathname: JOB_POSTING_FORM,
                    query: {
                      job_id: queryJobId,
                      re_post: true,
                      repost_campaign: true
                    }
                  });
                } else if (queryJobId) {
                  Router.push({
                    pathname: CANDIDATE_LISTING,
                    query: { job_id: queryJobId }
                  });
                } else {
                  Router.push(LOADING_PAGE);
                }
              }
            }
            resolve(recruiterData);
          })
          .catch(error => {
            let errorMessage = getErrorMessage(error);
            dispatch(getProfileFailure(errorMessage));
            // Update Zustand error state
            useUserProfileStore.getState().setProfileError(errorMessage);

            if (error && error.response && error.response.status == 403) {
              dispatch(showGenericSnackBar(LOGGED_OUT_MSG));
            } else {
              dispatch(showSnackBar(errorMessage));
            }
            reject(error);
          });
      } catch (error) {
        reject(error);
      }
    });
  };
};

export const getProfileLoading = () => {
  return {
    type: types.GET_PROFILE_LOADING
  };
};

export const getProfileSuccess = payload => {
  return {
    type: types.GET_PROFILE_SUCCESS,
    payload: payload
  };
};

export const getProfileFailure = error => {
  return {
    type: types.GET_PROFILE_FAILURE,
    payload: error
  };
};

export const logout = (callback, options = {}) => {
  const { redirect = true } = options;
  return dispatch => {
    dispatch(logoutLoading());
    makeAjaxRequest({
      method: "POST",
      url: fetchUrl("auth", "recruiter-logout")
    })
      .then(response => {
        dispatch(logoutSuccess(response.data));
        signOut(redirect);
        if (callback) {
          callback();
        }
      })
      .then(() => {
        dispatch(resetApplicationState());
        dispatch(showGenericSnackBar("Successfully logged-out."));
      })
      .catch(error => {
        let errorMessage = "";
        errorMessage = getErrorMessage(error);
        dispatch(logoutFailure(errorMessage));
        dispatch(showSnackBar(errorMessage));
      });
  };
};

export const logoutLoading = () => {
  return {
    type: types.LOGOUT_LOADING
  };
};

export const logoutSuccess = response => {
  return {
    type: types.LOGOUT_SUCCESS,
    payload: response
  };
};

export const logoutFailure = response => {
  return {
    type: types.LOGOUT_FAILURE,
    error: response
  };
};

export const resetApplicationState = () => {
  return {
    type: types.RESET_APPLICATION_STATE
  };
};

export const saveUserEmail = data => {
  return async dispatch => {
    await dispatch(getProfile({ hardCheck: true }));
  };
};

const setWebEngageData = recruiterData => {
  const {
    recruiter_id,
    email,
    full_name,
    phone,
    company,
    designation,
    image_url,
    is_soft_profile_completed,
    is_whatsapp_enabled,
    is_sms_enabled,
    last_login_tstamp,
    status,
    verification_source,
    hiring_in,
    jobs_count
  } = recruiterData;
  let hiringIn = [];
  if (hiring_in) {
    hiringIn = hiring_in.length && hiring_in.map(item => item).join(",");
  } else {
    hiringIn = "";
  }
  const trackingData = {
    we_first_name: full_name,
    we_email: email,
    we_phone: "91" + phone,
    we_company: company ? company.company_name : null,
    whatsappOptIn: is_whatsapp_enabled || true,
    smsOptIn: is_sms_enabled || true,
    "JHR Company Address": company ? company.company_address : null,
    "JHR Company Contact Info": company ? company.company_contact_info : null,
    "JHR Company Email": company ? company.company_email : null,
    "JHR Company Id": company ? company.company_id : null,
    "JHR Company Logo Url": company ? company.logo_url : null,
    "JHR Company Name": company ? company.company_name : null,
    "JHR Company Perks": company ? company.company_perks : null,
    "JHR Company Size":
      company !== null && company !== undefined ? company.company_size : null,
    "JHR Company Website": company ? company.company_website : null,
    "JHR Company about": company ? company.company_about : null,
    "JHR Created At": company ? company.createdAt : null,
    "JHR Designation": designation,
    "JHR Hiring In": hiringIn,
    "JHR Image Url": image_url,
    "JHR Is SoftProfile Completed": is_soft_profile_completed,
    "JHR Is Whatsapp Enable": is_whatsapp_enabled,
    "JHR Jobs Disabled": jobs_count ? jobs_count.DISABLED : null,
    "JHR Jobs Enabled":
      jobs_count !== null && jobs_count !== undefined
        ? jobs_count.ENABLED
        : null,
    "JHR Jobs Expired": jobs_count ? jobs_count.EXPIRED : null,
    "JHR Jobs Under Review":
      jobs_count !== null && jobs_count !== undefined
        ? jobs_count.UNDER_REVIEW
        : null,
    "JHR Jobs withdrawn":
      jobs_count !== null && jobs_count !== undefined
        ? jobs_count.WITHDRAWN
        : null,
    "JHR Last Login Timestamp": last_login_tstamp,
    "JHR Status": status,
    "JHR Verification Source": verification_source
  };

  ClmGetTrackingService().trackData(recruiterData);
};
